module.exports = __webpack_public_path__ + "static/img/8.a51425f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/8.png
// module id = lRYP
// module chunks = 0